<template>
    <div class="app-container">
        <el-tabs v-model="activetab">
            <el-tab-pane
                v-for="(tab, index) in tabList"
                :label="tab.moduleName"
                :key="index"
                :name="tab.moduleType"
            >
                <component
                    :is="tab.moduleType"
                    tabType="voucherSaiHu"
                    keep-alive
                ></component>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import storeBill from '@/views/voucherAdmin/voucherCreateSaiHuStoreBill'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    components: {
        storeBill
    },
    data() {
        return {
            tabList: [],
            activetab: '',
            VoucherCreateApi: config.BASE_Middle_API + 'VoucherCreate'
        }
    },
    mounted() {
        // this.tabList = this.childrenCloudTabList;
        // this.activetab = this.childrenCloudTabList[0].moduleType;
        this.getCloudModules()
    },

    methods: {
        getCloudModules() {
            const _this = this
            AjaxHelper.get(_this.VoucherCreateApi + '/getSaiHuModules')
                .then(function (response) {
                    if (response.success) {
                        _this.tabList = response.result
                        _this.activetab = _this.tabList[0].moduleType
                    }
                })
                .catch(function (error) {})
        }
    }
}
</script>

<style scoped>
.el-card {
    height: calc(100vh - 320px) !important;
}
</style>
